interface IntentionBoxProps {
  title: string;
  items: string[];
}

export function IntentionBox({ title, items }: IntentionBoxProps) {
  return (
    <div className="rounded-md border border-gray-200 p-3">
      <h4 className="mb-2 text-sm font-medium">{title}</h4>

      <ul className="space-y-1">
        {items.map((item, index) => (
          <li key={index} className="flex items-start text-sm text-gray-700">
            <span className="mr-2 text-gray-400">•</span>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
